export default __webpack_public_path__ + "static/media/personGlasses.d3608c42.PNG";